module.exports = __webpack_public_path__ + "static/media/french-club-example.b4ce68a2.png";